import React from 'react';
import { motion } from 'framer-motion';
import { Lot } from '../../types';
import { Home } from 'lucide-react';
interface LotOverlayProps {
  lot: Lot;
  isSelected: boolean;
  onSelect: (lot: Lot) => void;
}
export function LotOverlay({
  lot,
  isSelected,
  onSelect
}: LotOverlayProps) {
  const isSold = lot.status === 'sold';
  return <motion.button initial={{
    opacity: 0,
    scale: 0.8
  }} animate={{
    opacity: 1,
    scale: 1
  }} onClick={e => {
    e.stopPropagation();
    onSelect(lot);
  }} className="absolute transform -translate-x-1/2 -translate-y-1/2 group z-10" style={{
    left: `${lot.coordinates.x}%`,
    top: `${lot.coordinates.y}%`
  }} data-id="element-1141">
      {/* Pulse Effect for Available Lots */}
      {!isSold && !isSelected && <motion.div className="absolute inset-0 rounded-full bg-cyan-500 opacity-20" animate={{
      scale: [1, 1.5],
      opacity: [0.2, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeOut'
    }} data-id="element-1142" />}

      {/* Marker Circle */}
      <div className={`
          relative w-12 h-12 rounded-full flex flex-col items-center justify-center shadow-lg border-2 transition-all duration-300
          ${isSelected ? 'bg-cyan-500 border-white scale-110' : isSold ? 'bg-slate-800 border-slate-600 opacity-80' : 'bg-slate-900 border-white/30 hover:bg-cyan-500 hover:border-white hover:scale-105'}
        `} data-id="element-1143">
        <span className={`text-sm font-bold ${isSelected || !isSold && !isSelected ? 'text-white' : 'text-slate-400'}`} data-id="element-1144">
          {lot.id}
        </span>
        <span className={`text-[8px] uppercase tracking-wider ${isSelected || !isSold && !isSelected ? 'text-white/80' : 'text-slate-500'}`} data-id="element-1145">
          {isSold ? 'Sold' : 'Lot'}
        </span>
      </div>

      {/* Hover Label - Fixed Position to prevent jumping */}
      <div className="absolute top-14 left-1/2 -translate-x-1/2 pointer-events-none" data-id="element-1146">
        <div className={`
            whitespace-nowrap px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider shadow-xl backdrop-blur-md transition-all duration-300
            ${isSelected ? 'bg-cyan-500 text-white opacity-100 translate-y-0' : 'bg-slate-900/90 text-white opacity-0 translate-y-[-4px] group-hover:opacity-100 group-hover:translate-y-0'}
          `} data-id="element-1147">
          {isSold ? 'Sold' : 'Available'}
        </div>
      </div>
    </motion.button>;
}